import {
  WP_REST_API_Attachment,
  WP_REST_API_Categories,
  WP_REST_API_Post
} from 'wp-types';

export function getPostThumb(post: WP_REST_API_Post): string | undefined {
  const embedded = post._embedded?.['wp:featuredmedia'];
  const media =
    embedded && embedded[0]
      ? (embedded[0] as WP_REST_API_Attachment)
      : undefined;

  return media ? media.source_url : undefined;
}
export const hiddenCategories = [
  'uncategorized',
  'uncategorised',
  'oculto',
  'sin-categorizar',
  'all',
  'todo-el-blog'
] as const;

export function getPostCategoriesId(
  post: WP_REST_API_Post,
  categories: WP_REST_API_Categories
): string[] | undefined {
  if (!post.categories || !categories) {
    return undefined;
  }

  return post.categories
    .map((catId) => {
      const category = categories.find((c) => c.id === catId);
      return category ? category.name : '';
    })
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));
}

export const sortCategories = (categories: WP_REST_API_Categories) => {
  const specialFirst = (
    a: WP_REST_API_Categories[number],
    b: WP_REST_API_Categories[number]
  ) => {
    if (a.id === 304) return -1;
    if (b.id === 304) return 1;
    return a.name.localeCompare(b.name);
  };

  return {
    parent: categories.filter((cat) => cat.parent === 0).sort(specialFirst),

    children: categories
      .filter((cat) => cat.parent !== 0)
      .sort((a, b) => a.name.localeCompare(b.name))
  };
};
